// extracted by mini-css-extract-plugin
export var fadeUp = "search-result-module--fadeUp--a347a";
export var fadeUpAnime = "search-result-module--fadeUpAnime--0fa87";
export var hits = "search-result-module--hits--64255";
export var loading = "search-result-module--loading--fe762";
export var message = "search-result-module--message--0ead4";
export var result = "search-result-module--result--e7f1f";
export var result_excerpt = "search-result-module--result_excerpt--86248";
export var result_heading = "search-result-module--result_heading--88133";